import React, { useEffect } from 'react';
import styles from '../static/styles/Thankyou.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import ArrowLeft from '../static/img/backArrow.png'

const Thankyou = () => {
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        document.title = "Thankyou | Jazz ESL";
    }, []);
    const reward = location.state?.reward || {};
    const gameId = location.state?.gameId || '';
    const phone = location.state?.phone || '';
    const email = location.state?.email || '';
    const name = location.state?.name || '';

    
    return (
        <div className={styles.container}>

            {/* HEADER */}
            <div className={styles.navigationHeader}>
                <div
                    className={styles.navigationBack}
                    onClick={() => navigate(-1)}
                >
                    <img src={ArrowLeft} alt="<" />
                </div>
                <div className={styles.navigationTitle}>
                    <p>order placed</p>
                    <h2 className={styles.heading}>redeem complete</h2>
                </div>
            </div>

            {/* SUCCESS ICON */}
            <div className={styles.successWrap}>
                <div className={styles.checkCircle}></div>
            </div>

            <div className={`${styles.statusBadge} ${styles.fadeUp} ${styles.delay1}`}>
                ● ORDER CONFIRMED
            </div>

            {/* TEXT */}
            <h2 className={`${styles.mainTitle} ${styles.fadeUp} ${styles.delay2}`}>THANK YOU!</h2>

            <p className={`${styles.subText} ${styles.fadeUp} ${styles.delay3}`}>
                Your reward is being processed.<br />
                We will deliver it to your gaming account shortly.
            </p>

            {/* RECEIPT CARD */}
            <div className={`${styles.receiptCard} ${styles.fadeUp} ${styles.delay4}`}>
                <div className={styles.receiptHeader}>
                    <span>ORDER RECEIPT</span>
                    <strong>#ESL</strong>
                </div>

                <div className={styles.row}>
                    <span>Phone</span>
                    <span>{phone || '0'}</span>
                </div>

                <div className={styles.row}>
                    <span>Email</span>
                    <span>{email || 'nill'}</span>
                </div>

                <div className={styles.row}>
                    <span>Name</span>
                    <span>{name || 'nill'}</span>
                </div>

                <div className={styles.row}>
                    <span>Item</span>
                    <span>{reward.name || '0'}</span>
                </div>

                <div className={styles.row}>
                    <span>Game ID</span>
                    <span>{gameId || 'nill'}</span>
                </div>

                <div className={styles.row}>
                    <span>Cost</span>
                    <span>{reward.credits || 0} credits</span>
                </div>

                <div className={styles.row}>
                    <span>ETA</span>
                    <span>
                        {reward.game === null ? 'Within 7 days' : '24–48 hours'}
                    </span>
                </div>
            </div>

            {/* BUTTONS */}
            <button className={`${styles.primaryBtn} ${styles.fadeUp} ${styles.delay5}`}
                onClick={() => navigate('/rewards')}
            >
                BACK TO REDEEM →
            </button>

            {/* <button className={`${styles.secondaryBtn} ${styles.fadeUp} ${styles.delay5}`}>
                TRACK ORDER STATUS →
            </button> */}

        </div>
    );
};

export default Thankyou;